import { Option } from './option'

export const REGION = {
  HOKKAIDO: 1,
  AOMORI: 2,
  IWATE: 3,
  MIYAGI: 4,
  AKITA: 5,
  YAMAGATA: 6,
  FUKUSHIMA: 7,
  IBARAKI: 8,
  TOCHIGI: 9,
  GUNMA: 10,
  SAITAMA: 11,
  CHIBA: 12,
  TOKYO: 13,
  KANAGAWA: 14,
  NIIGATA: 15,
  TOYAMA: 16,
  ISHIKAWA: 17,
  FUKUI: 18,
  YAMANASHI: 19,
  NAGANO: 20,
  GIFU: 21,
  SHIZUOKA: 22,
  AICHI: 23,
  MIE: 24,
  SHIGA: 25,
  KYOTO: 26,
  OSAKA: 27,
  HYOGO: 28,
  NARA: 29,
  WAKAYAMA: 30,
  TOTTORI: 31,
  SHIMANE: 32,
  OKAYAMA: 33,
  HIROSHIMA: 34,
  YAMAGUCHI: 35,
  TOKUSHIMA: 36,
  KAGAWA: 37,
  EHIME: 38,
  KOCHI: 39,
  FUKUOKA: 40,
  SAGA: 41,
  NAGASAKI: 42,
  KUMAMOTO: 43,
  OITA: 44,
  MIYAZAKI: 45,
  KAGOSHIMA: 46,
  OKINAWA: 47,
}

export const REGION_OPTIONS: Option[] = [
  { label: '北海道', value: REGION.HOKKAIDO },
  { label: '青森県', value: REGION.AOMORI },
  { label: '岩手県', value: REGION.IWATE },
  { label: '宮城県', value: REGION.MIYAGI },
  { label: '秋田県', value: REGION.AKITA },
  { label: '山形県', value: REGION.YAMAGATA },
  { label: '福島県', value: REGION.FUKUSHIMA },
  { label: '茨城県', value: REGION.IBARAKI },
  { label: '栃木県', value: REGION.TOCHIGI },
  { label: '群馬県', value: REGION.GUNMA },
  { label: '埼玉県', value: REGION.SAITAMA },
  { label: '千葉県', value: REGION.CHIBA },
  { label: '東京都', value: REGION.TOKYO },
  { label: '神奈川県', value: REGION.KANAGAWA },
  { label: '新潟県', value: REGION.NIIGATA },
  { label: '富山県', value: REGION.TOYAMA },
  { label: '石川県', value: REGION.ISHIKAWA },
  { label: '福井県', value: REGION.FUKUI },
  { label: '山梨県', value: REGION.YAMANASHI },
  { label: '長野県', value: REGION.NAGANO },
  { label: '岐阜県', value: REGION.GIFU },
  { label: '静岡県', value: REGION.SHIZUOKA },
  { label: '愛知県', value: REGION.AICHI },
  { label: '三重県', value: REGION.MIE },
  { label: '滋賀県', value: REGION.SHIGA },
  { label: '京都府', value: REGION.KYOTO },
  { label: '大阪府', value: REGION.OSAKA },
  { label: '兵庫県', value: REGION.HYOGO },
  { label: '奈良県', value: REGION.NARA },
  { label: '和歌山県', value: REGION.WAKAYAMA },
  { label: '鳥取県', value: REGION.TOTTORI },
  { label: '島根県', value: REGION.SHIMANE },
  { label: '岡山県', value: REGION.OKAYAMA },
  { label: '広島県', value: REGION.HIROSHIMA },
  { label: '山口県', value: REGION.YAMAGUCHI },
  { label: '徳島県', value: REGION.TOKUSHIMA },
  { label: '香川県', value: REGION.KAGAWA },
  { label: '愛媛県', value: REGION.EHIME },
  { label: '高知県', value: REGION.KOCHI },
  { label: '福岡県', value: REGION.FUKUOKA },
  { label: '佐賀県', value: REGION.SAGA },
  { label: '長崎県', value: REGION.NAGASAKI },
  { label: '熊本県', value: REGION.KUMAMOTO },
  { label: '大分県', value: REGION.OITA },
  { label: '宮崎県', value: REGION.MIYAZAKI },
  { label: '鹿児島県', value: REGION.KAGOSHIMA },
  { label: '沖縄県', value: REGION.OKINAWA },
]
